import { render, staticRenderFns } from "./Galeri.vue?vue&type=template&id=4dfb7fbb&scoped=true&"
import script from "./Galeri.vue?vue&type=script&lang=js&"
export * from "./Galeri.vue?vue&type=script&lang=js&"
import style0 from "./Galeri.vue?vue&type=style&index=0&id=4dfb7fbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb7fbb",
  null
  
)

export default component.exports